import React from 'react';
import LinkTreeManager from './LinkTreeManager';
import { useStorefrontSettings } from '../Storefront/useStorefrontSettings';

export default function LinkTreeManagerSection(props) {
    const storefront = useStorefrontSettings();
    return <LinkTreeManager storefrontUrl={storefront.data?.url} {...props} />;
}
